import { Navigate } from "react-router-dom";

// Road Alert
import DashboardRoadAlert from "../pages/RoadAlert/Dashboard";
import AlertesList from "../pages/RoadAlert/AlertesList";
import AlerteDetail from "../pages/RoadAlert/AlerteDetail";
import Parametres from "../pages/RoadAlert/Parametres";
import ExportationData from "../pages/RoadAlert/ExportationData";
import Etats from "../pages/RoadAlert/Etats";
import Cartographie from "../pages/RoadAlert/Cartographie";

// Auth
import Logout from "../pages/Authentication/Logout";
import UserProfile from "../pages/Authentication/user-profile";
import LoginAlerte from "pages/Authentication/LoginAlerte";
import WelcomeBackAlerte from "pages/Authentication/WelcomeBackAlerte";

const roadAlertRoutes = [
  { path: "/dashboard-alertes", component: <DashboardRoadAlert /> },
  { path: "/alertes-grand-public", component: <AlertesList title="Alertes grands publics" idStatutAlerte="7" /> },
  { path: "/alertes-non-affectees", component: <AlertesList title="Alertes non affectées" idStatutAlerte="1" /> },
  { path: "/alertes-non-demarrees", component: <AlertesList title="Alertes non démarrées" idStatutAlerte="2" /> },
  { path: "/alertes-en-pause", component: <AlertesList title="Alertes en pause" idStatutAlerte="3" /> },
  { path: "/alertes-en-cours", component: <AlertesList title="Alertes en cours" idStatutAlerte="6" /> },
  { path: "/alertes-terminees", component: <AlertesList title="Alertes terminées" idStatutAlerte="4" /> },
  { path: "/alertes-arretees", component: <AlertesList title="Alertes arrêtées" idStatutAlerte="5" /> },
  { path: "/parametres", component: <Parametres /> },
  { path: "/etats", component: <Etats /> },
  { path: "/exportation-data", component: <ExportationData /> },
  { path: "/cartographie", component: <Cartographie /> },
  { path: "/alertes/:id", component: <AlerteDetail /> },
  { path: "/profile", component: <UserProfile /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard-alertes" />,
  },
  { path: "*", component: <Navigate to="/dashboard-alertes" /> },
];

const authProtectedRoutes = [...roadAlertRoutes];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <LoginAlerte /> },
  { path: "/welcome-back", component: <WelcomeBackAlerte /> },
];

export { authProtectedRoutes, publicRoutes };
